<template>
  <div class="dynamic">
    <z-week :weekList="weekList"></z-week>
    <z-month :monthList="monthList"></z-month>
    <div class="clear margin_bottom"></div>
    <z-earlier :earlierList="earlierList"></z-earlier>
    <div class="margin_bottom"></div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="pages.pageNum"
      :page-size="pages.pageSize"
      layout="prev, pager, next, jumper"
      :total="pages.total" small>
    </el-pagination>
  </div>
</template>

<script>
import week from '@/components/dynamic/week'
import month from '@/components/dynamic/month'
import earlier from '@/components/dynamic/earlier'
export default {
  name: 'dynamic',
  components: {
    'z-week': week,
    'z-month': month,
    'z-earlier': earlier
  },
  data () {
    return {
      weekList: [],
      monthList: [],
      earlierList: [],
      pages: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created () {
  },
  mounted () {
    this.loadDxdt()
  },
  computed: {
    params () {
      let param = {}
      param.cls = 1
      param.pageNum = this.pages.pageNum
      param.pageSize = this.pages.pageSize
      return param
    }
  },
  methods: {
    loadDxdt () {
      this.$axios.dxdt(this.params).then(res => {
        if (res) {
          this.weekList = res.data.data.leftUpper
          this.monthList = res.data.data.rightUpper
          this.earlierList = res.data.data.bottom.list
          this.pages.total = res.data.data.bottom.total
        }
      })
    },
    handleCurrentChange (val) {
      this.pages.pageNum = val
      this.loadDxdt()
    }
  },
  watch: {}
}
</script>

<style scoped>
  .dynamic .margin_bottom { margin-bottom: 20px; }
  .dynamic .el-pagination { text-align: right; }
</style>



// WEBPACK FOOTER //
// src/pages/dynamic/index.vue